/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Apple_Link_TitleInputs */

const de_login_apple_link_title = /** @type {(inputs: Login_Apple_Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple-Konto verknüpfen`)
};

/** @type {(inputs: Login_Apple_Link_TitleInputs) => LocalizedString} */
const en_login_apple_link_title = de_login_apple_link_title;

/**

* @param {Login_Apple_Link_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_apple_link_title = /** @type {((inputs?: Login_Apple_Link_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Apple_Link_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_apple_link_title(inputs)
	return en_login_apple_link_title(inputs)
});